/* eslint-disable react/no-unknown-property */
/* eslint-disable max-len */
import React from 'react';

/**
 * ArrowDownIcon - Auto-generated from icon.js
 */
export const ArrowDownIcon = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
	<svg
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			d="M12.0013 16.0013C11.7676 16.0017 11.5412 15.9203 11.3613 15.7713L5.36125 10.7713C5.15704 10.6015 5.02861 10.3576 5.00423 10.0932C4.97985 9.82875 5.06151 9.56547 5.23125 9.36125C5.40099 9.15704 5.6449 9.02861 5.90933 9.00423C6.17375 8.97985 6.43704 9.06151 6.64125 9.23125L12.0013 13.7113L17.3613 9.39125C17.4635 9.30819 17.5812 9.24615 17.7076 9.20872C17.8339 9.17129 17.9664 9.1592 18.0974 9.17314C18.2285 9.18708 18.3554 9.22677 18.4711 9.28995C18.5867 9.35312 18.6887 9.43853 18.7713 9.54125C18.8628 9.64407 18.9322 9.7647 18.975 9.89557C19.0178 10.0264 19.0331 10.1647 19.0199 10.3018C19.0068 10.4389 18.9655 10.5717 18.8986 10.6921C18.8317 10.8125 18.7407 10.9177 18.6313 11.0013L12.6313 15.8313C12.4462 15.9568 12.2244 16.0166 12.0013 16.0013Z"
			fill="#676767"
		/>
	</svg>
);

export default ArrowDownIcon;
